<template>
  <div class="inputDropdown dropdown operator-input" title="Filter type">
    <button class="dropdown-button" @click="active = !active">
      <awesomeIcon v-if="display === '='" icon="equals"/>
      <awesomeIcon v-if="display === '!='" icon="not-equal"/>
      <awesomeIcon v-if="display === '>'" icon="greater-than"/>
      <awesomeIcon v-if="display === '<'" icon="less-than"/>
      <awesomeIcon v-if="display === '>='" icon="greater-than-equal"/>
      <awesomeIcon v-if="display === '<='" icon="less-than-equal"/>
      <span v-else-if="!['=', '!=', '>', '<', '>=', '<='].includes(display)">
        {{ display }}
      </span>
    </button>
    <transition name="fade">
      <div class="dropdown-bg" v-if="active" @click="active = false"></div>
    </transition>
    <transition name="fade">
      <div class="dropdown-body">
        <ul class="dropdown-list" v-if="active">
          <li v-for="(item, index) in filter(
            operators, (obj) => $props.allowed.includes(obj.value)
          )" :key="index" @click="select(item)" :class="{ 'selected-operator': item.selected }">
            <span v-if="
              item.label === 'Meer dan'
              && $props.inputType === 'date'
            ">
              Later dan
            </span>
            <span v-else-if="
              item.label === 'Minder dan'
              && $props.inputType === 'date'
            ">
              Eerder dan
            </span>
            <span v-else-if="
              item.label === 'Gelijk aan of meer dan'
              && $props.inputType === 'date'
            ">
              Gelijk aan of later dan
            </span>
            <span v-else-if="
              item.label === 'Gelijk aan of minder dan'
              && $props.inputType === 'date'
            ">
              Gelijk aan of eerder dan
            </span>
            <span v-else>{{ item.label }}</span>
            <span class="operator">
              <awesomeIcon v-if="item.value === 'eq'" icon="equals"/>
              <awesomeIcon v-if="item.value === 'neq'" icon="not-equal"/>
              <awesomeIcon v-if="item.value === 'gt'" icon="greater-than"/>
              <awesomeIcon v-if="item.value === 'lt'" icon="less-than"/>
              <awesomeIcon v-if="item.value === 'eqgt'" icon="greater-than-equal"/>
              <awesomeIcon v-if="item.value === 'eqlt'" icon="less-than-equal"/>
              <span v-else-if="!['eq', 'neq', 'gt', 'lt', 'eqgt', 'eqlt'].includes(item.value)">
                {{ item.operator }}
              </span>
            </span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>
<script>
import { filter, find, forEach } from 'lodash-es';

export default {
  name: 'OperatorInput',
  emits: ['update:model-value'],
  props: {
    allowed: {
      type: Array,
      default: () => ['contains', 'startswith', 'endswith', 'eq', 'neq', 'gt', 'lt', 'eqgt', 'eqlt'],
    },
    modelValue: {
      type: String,
      default: 'eq',
    },
    inputType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      active: false,
      display: '',
      operators: [
        {
          label: 'Bevat',
          operator: '...input...',
          shortDisplay: '...A...',
          value: 'contains',
        },
        {
          label: 'Start met',
          operator: 'input...',
          shortDisplay: 'A...',
          value: 'startswith',
        },
        {
          label: 'Eindigt met',
          operator: '...input',
          shortDisplay: '...A',
          value: 'endswith',
        },
        {
          label: 'Gelijk aan',
          operator: '=',
          shortDisplay: '=',
          value: 'eq',
        },
        {
          label: 'Niet gelijk aan',
          operator: '!=',
          shortDisplay: '!=',
          value: 'neq',
        },
        {
          label: 'Meer dan',
          operator: '>',
          shortDisplay: '>',
          value: 'gt',
        },
        {
          label: 'Minder dan',
          operator: '<',
          shortDisplay: '<',
          value: 'lt',
        },
        {
          label: 'Gelijk aan of meer dan',
          operator: '>=',
          shortDisplay: '>=',
          value: 'eqgt',
        },
        {
          label: 'Gelijk aan of minder dan',
          operator: '<=',
          shortDisplay: '<=',
          value: 'eqlt',
        },
      ],
    };
  },
  watch: {
    modelValue() {
      this.setDisplay(filter(this.operators, { value: this.$props.modelValue })[0]);
    },
  },
  created() {
    this.setDisplay();
  },
  methods: {
    filter,
    reset() {
      this.setDisplay();
    },
    setDisplay(item) {
      let selectedOperator = item;

      if (!selectedOperator) {
        selectedOperator = find(
          filter(
            this.operators,
            (obj) => this.$props.allowed.includes(obj.value),
          ),
          { value: this.$props.modelValue },
        );
      }

      forEach(this.operators, (obj) => {
        delete obj.selected;
      });

      this.display = selectedOperator.shortDisplay;
      selectedOperator.selected = true;
    },
    select(item) {
      this.active = false;
      this.setDisplay(item);
      this.$emit('update:model-value', item.value);
    },
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.inputDropdown.operator-input {
  padding: 0;
  width: 35px !important;
  margin-right: 2px;

  button {
    border-radius: 0;
    white-space: nowrap;
    background-color: #ffffff;
    padding: 0;
    width: 35px;
    font-weight: bold;

    &:hover {
      background-color: rgba(#ffffff, 0.5);
    }
  }

  .dropdown-body {
    width: auto;
    height: auto;
    position: absolute;
    z-index: 99;
    border-radius: 6px;
    overflow: hidden;
    border-top-left-radius: 0;

    ul {
      display: table;
      min-width: 80px;
      position: relative;
      border-radius: 0;

      li {
        white-space: nowrap;
        display: flex;
        justify-content: space-between;

        &.selected-operator {
          background-color: rgba($color-highlight, 0.5);
        }

        &:hover {
          background-color: #eee;
        }

        span.operator {
          color: rgba(#000, 0.5);
          margin-left: 15px;
          font-weight: bold;
        }
      }
    }
  }
}</style>
